import reducer, { eventsTypes } from './duck';

export { TradeBot } from './containers/index';
export const tradeBotsModule = {
  reducer: reducer,
  eventsTypes: eventsTypes,
};
